import { useCallback, useRef } from 'react';

const DEFAULT_THROTTLE_MS = 1500;

type Callback = (...args: any[]) => void;

export const useThrottleCallback = (
  callback: Callback,
  delay: number = DEFAULT_THROTTLE_MS
): Callback => {
  const lastCallTime = useRef<number | null>(null);
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

  const throttledFunction = useCallback(
    (...args: any[]) => {
      const now = Date.now();

      if (lastCallTime.current === null || now - lastCallTime.current >= delay) {
        callback(...args);
        lastCallTime.current = now;
      } else {
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }

        timeoutId.current = setTimeout(() => {
          callback(...args);
          lastCallTime.current = Date.now();
        }, delay - (now - lastCallTime.current));
      }
    },
    [callback, delay]
  );

  return throttledFunction;
};

export default useThrottleCallback;
